import { FC } from 'react'
import { DemoEnvironmentList } from '../components/resources/DemoEnvironmentList'
import { DemoEnvironmentShow } from '../components/resources/demoEnvironment_components/DemoEnvironmentShow'
import { DemoEnvironmentEdit } from '../components/resources/demoEnvironment_components/DemoEnvironmentEdit'
import DemoEnvironmentCreate from '../components/resources/demoEnvironment_components/DemoEnvironmentCreate'
import { UserList } from '../components/resources/UserList'
import { UserShow } from '../components/resources/user_components/UserShow'
import { UserEdit } from '../components/resources/user_components/UserEdit'
import UserCreate from '../components/resources/user_components/UserCreate'
import { SchoolList } from '../components/resources/SchoolList'
import { SchoolEdit } from 'components/resources/school_components/SchoolEdit'
import { SchoolShow } from '../components/resources/school_components/SchoolShow'
import SchoolCreate from '../components/resources/school_components/SchoolCreate'
import { DistrictList } from 'components/resources/DistrictList'
import { DistrictShow } from 'components/resources/district_components/DistrictShow'
import { DistrictEdit } from '../components/resources/district_components/DistrictEdit'
import { ClassShow } from '../components/resources/class_components/ClassShow'
import { AssignmentAttemptList } from '../components/resources/assignment_attempt_components/AssignmentAttemptList'
import DistrictCreate from '../components/resources/district_components/DistrictCreate'
import AdminTools from 'components/resources/AdminTools'
import { Partner } from '../components/resources/products/Partner'
import { EditableResourceList } from '../components/resources/resourceList/EditableResourceList'
import { ProductSingleResource } from '../components/resources/products/Product'
import { Group } from '../components/resources/products/Group'
import { Crosswalk } from 'domains/scope-and-sequence/features/crosswalk/Crosswalk'
import type { ResourceKey } from '../components/resources/resourceList/atoms'

type ResourceData = {
  title: string
  key: ResourceKey
  List?: FC
  Single?: FC<{ id: string; resourceKey: string }>
  Edit?: FC<{ id: string }>
  Create?: FC
  unlisted?: boolean
}

export const resources: ResourceData[] = [
  {
    title: 'Users',
    key: 'users',
    List: UserList,
    Single: UserShow,
    Edit: UserEdit,
    Create: UserCreate,
  },
  {
    title: 'Schools',
    key: 'schools',
    List: SchoolList,
    Single: SchoolShow,
    Edit: SchoolEdit,
    Create: SchoolCreate,
  },
  {
    title: 'Districts',
    key: 'districts',
    List: DistrictList,
    Single: DistrictShow,
    Edit: DistrictEdit,
    Create: DistrictCreate,
  },
  {
    title: 'Demos',
    key: 'demos',
    List: DemoEnvironmentList,
    Single: DemoEnvironmentShow,
    Edit: DemoEnvironmentEdit,
    Create: DemoEnvironmentCreate,
  },
  {
    title: 'Class Info',
    key: 'class',
    List: ClassShow,
  },
  {
    title: 'Attempts',
    key: 'assignmentAttempts',
    List: AssignmentAttemptList,
    unlisted: true,
  },
  {
    title: 'Products',
    key: 'products',
    List: EditableResourceList,
    Single: ProductSingleResource,
  },
  {
    title: 'Partners',
    key: 'partners',
    List: EditableResourceList,
    Single: Partner,
  },
  {
    title: 'Admin Tools',
    key: 'admintools',
    List: AdminTools,
  },
  {
    title: 'Product Groups',
    key: 'productGroups',
    List: EditableResourceList,
    Single: Group,
    unlisted: true,
  },
  {
    title: 'Primary Trees',
    key: 'primaryTrees',
    List: EditableResourceList,
    unlisted: true,
  },
  {
    title: 'Editable Trees',
    key: 'editableTrees',
    List: EditableResourceList,
    unlisted: true,
  },
  {
    title: 'Crosswalk Mapping Sets',
    key: 'crosswalkMappingSets',
    unlisted: true,
    Single: Crosswalk,
  },
]
